export default __webpack_public_path__ + "dist/img/step-5.png";